import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';

import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface StateListProps {
  value: string | undefined;
  disabled?: boolean;
  error?: boolean;
  onChange: (type: ItemVM | undefined) => void;
  label?: string;
  required?: boolean;
  id?: string;
}

export const jobStatus: Array<ItemVM> = [
  {
    id: '1',
    value: 'STARTED',
  },
  {
    id: '2',
    value: 'RUNNING',
  },
  {
    id: '3',
    value: 'SUCCESS',
  },
  {
    id: '4',
    value: 'ERROR',
  },
];
const StateListComponent = ({
  value,
  disabled,
  onChange,
  required,
  error,
  label = 'Stato',
  id = 'state',
}: StateListProps): React.ReactElement => {
  const idTag = `${id}-${label}`;

  /*
  const [jobExecutionStatuses] = useHttpFetch<HttpResponse<Array<string>>, Array<ItemVM>>(
    `${__OPERATION__BATCH__}/executions/types/jobExecutionStatuses`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: [],
      },
      transformer: (response: AxiosResponse<HttpResponse<Array<string>>>) => {
        return response.data.payload.map((item, index) => {
          const itemResult: ItemVM = {
            id: index + 1,
            value: item,
          };
          return itemResult;
        });
      },
    }
  );


  const jobExecutionStatusesList = useMemo(() => {
    const data = (jobExecutionStatuses?.data as Array<ItemVM>) || [];
    return data;
  }, [jobExecutionStatuses]);
  */

  return (
    <PmiFormControl fullWidth>
      <InputLabel id={idTag}>{required ? `${label} *` : label}</InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        error={error}
        defaultValue=""
        label={required ? `${label} *` : label}
        disabled={disabled}
        value={value}
        onChange={(event: SelectChangeEvent<string>) => {
          const selectedItem: ItemVM | undefined = jobStatus?.find(
            (itemCurr) => itemCurr.id === event.target.value
          );
          onChange(selectedItem);
        }}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {jobStatus?.map((job) => (
          <MenuItem key={job?.id} value={job?.id}>
            {job?.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

StateListComponent.displayName = 'Job state list Select';

export const StateList = memo(StateListComponent) as typeof StateListComponent;

export default StateList;
